var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7683 6.44658C11.8849 3.8386 9.05457 2.44056 6.44658 3.32397C3.8386 4.20739 2.44056 7.03773 3.32397 9.64572C3.59491 10.4456 3.16614 11.3136 2.36628 11.5846C1.56641 11.8555 0.698354 11.4267 0.427413 10.6269C-0.997887 6.41917 1.25771 1.85271 5.46542 0.427413C9.67313 -0.997887 14.2396 1.25771 15.6649 5.46542C17.0902 9.67313 14.8346 14.2396 10.6269 15.6649C9.82702 15.9358 8.95896 15.5071 8.68802 14.7072C8.41708 13.9073 8.84585 13.0393 9.64572 12.7683C12.2537 11.8849 13.6517 9.05457 12.7683 6.44658Z",
    fill: "#1D1D38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48953 13.3108C10.1795 12.8237 11.1336 12.9882 11.6206 13.6782L15.8813 19.7141C17.1523 21.5148 15.8645 24 13.6605 24H3.13799C0.83333 24 -0.42566 21.312 1.04975 19.5415L1.7511 18.6999C2.29174 18.0511 3.25595 17.9635 3.90472 18.5041C4.55348 19.0448 4.64114 20.009 4.1005 20.6577L3.86379 20.9418H13.0044L9.12211 15.4418C8.6351 14.7519 8.7996 13.7978 9.48953 13.3108Z",
    fill: "#1D1D38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.902 14.8253C5.902 15.6698 5.21739 16.3544 4.37288 16.3544C3.52838 16.3544 2.84377 15.6698 2.84377 14.8253C2.84377 13.9808 3.52838 13.2962 4.37288 13.2962C5.21739 13.2962 5.902 13.9808 5.902 14.8253Z",
    fill: "#1D1D38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.944d1fc3.svg";
export { ForwardRef as ReactComponent };